/**
 * PDP2026 Q2 mobile size-hero: updates the spec card from variant.option2 (+ price),
 * and swaps the hero image / lightbox link to variant.featured_image (from variant-radios JSON).
 * Keep SIZE_SPEC keys in sync with snippets/product-options-pdp2026q2.liquid.
 *
 * Also syncs --pdp2026-size-accent on .product-sizes-colors--pdp2026q2 so the selected
 * quilt size tile border (and fleece swatch ring) match the chosen fleece color.
 */
(function () {
  var PDP_CLASS = 'template-product-quilt-product-new-pdp2026q2';
  var DEFAULT_FLEECE_ACCENT = '#0b63ce';

  /** When swatches use texture images, --background-graphic is url(...); use these accents. */
  var FLEECE_ACCENT_BY_VALUE = {
    Gray: '#8a9099',
    'Sweatshirt - Gray': '#8a9099',
    'Navy Blue': '#1e3a5f',
    'Sweatshirt - Navy Blue': '#1e3a5f',
    'Light Blue': '#5b8fc7',
    Black: '#1a1a1a',
    Orchid: '#b565c8',
    Green: '#2e7d4a',
    Red: '#c0392b',
    'Double Sided': '#0b63ce',
  };

  var SIZE_SPEC = {
    'Mini Throw': { sides: '9', dims: '36″ × 36″' },
    'Bed Runner': { sides: '12', dims: '72″ × 24″' },
    Lap: { sides: '16', dims: '48″ × 48″' },
    Twin: { sides: '24', dims: '48″ × 72″' },
    'Twin XL': { sides: '28', dims: '48″ × 84″' },
    Full: { sides: '30', dims: '60″ × 72″' },
    'Large Throw': { sides: '36', dims: '72″ × 72″' },
    Queen: { sides: '42', dims: '72″ × 84″' },
    King: { sides: '64', dims: '96″ × 96″' },
  };

  function formatVariantMoney(cents) {
    if (cents == null || typeof Shopify === 'undefined' || !Shopify.formatMoney) return '';
    var fmt = typeof theme !== 'undefined' && theme && theme.money_format ? theme.money_format : '{{amount}}';
    return Shopify.formatMoney(cents, fmt);
  }

  function updateSpecCard(variant) {
    var card = document.querySelector('[data-pdp2026-spec-card]');
    if (!card || !variant) return;

    var sizeLabel = variant.option2;
    if (sizeLabel == null || sizeLabel === '') return;

    var spec = SIZE_SPEC[sizeLabel];
    var sidesEl = card.querySelector('[data-spec-sides]');
    var dimsEl = card.querySelector('[data-spec-dims]');
    var priceEl = card.querySelector('[data-spec-price]');
    if (!spec) {
      return;
    }
    if (sidesEl) sidesEl.textContent = spec.sides;
    if (dimsEl) dimsEl.textContent = spec.dims;
    if (priceEl) {
      priceEl.textContent = formatVariantMoney(variant.price);
    }
  }

  /** Mobile size-hero image: use the selected variant’s featured image only. */
  function updateHeroImage(variant) {
    if (!variant || !variant.featured_image || !variant.featured_image.src) return;
    var src = variant.featured_image.src;
    var img =
      document.querySelector('.pdp-mobile-optimized .pdp2026-size-hero__img') ||
      document.querySelector('.pdp-mobile-optimized .pdp-mobile-size-image div:first-child img');
    var link = document.querySelector('.pdp-mobile-size-image-pop');
    if (img) img.src = src;
    if (link) link.setAttribute('href', src);
  }

  function accentFromCssGraphicValue(raw) {
    if (!raw) return null;
    var v = String(raw).trim();
    if (/^rgb(a)?\(/i.test(v)) return v;
    if (/^#[0-9a-f]{3,8}$/i.test(v)) return v;
    return null;
  }

  function getFleeceAccentForContainer(container) {
    if (!container) return DEFAULT_FLEECE_ACCENT;
    var checked = container.querySelector('.pdp2026-fleece-item input[type="radio"]:checked');
    if (!checked) return DEFAULT_FLEECE_ACCENT;

    var item = checked.closest('.pdp2026-fleece-item');
    var swatch = item && item.querySelector('variant-swatch');
    if (swatch) {
      var graphic = getComputedStyle(swatch).getPropertyValue('--background-graphic').trim();
      var fromColor = accentFromCssGraphicValue(graphic);
      if (fromColor) return fromColor;
    }

    var val = checked.value;
    if (val && FLEECE_ACCENT_BY_VALUE[val]) return FLEECE_ACCENT_BY_VALUE[val];
    return DEFAULT_FLEECE_ACCENT;
  }

  function syncFleeceAccent(container) {
    if (!container) return;
    var accent = getFleeceAccentForContainer(container);
    container.style.setProperty('--pdp2026-size-accent', accent);
  }

  function bindFleeceAccent(container) {
    if (!container) return;
    var row = container.querySelector('.pdp2026-fleece-swatches__row');
    if (row) {
      row.addEventListener('change', function (e) {
        if (e.target && e.target.matches && e.target.matches('.pdp2026-fleece-item input[type="radio"]')) {
          syncFleeceAccent(container);
        }
      });
    }
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        syncFleeceAccent(container);
      });
    });
  }

  function init() {
    if (!document.body.classList.contains(PDP_CLASS)) return;
    var vr = document.querySelector('variant-radios.pdp2026-variant-radios');
    if (!vr) return;
    var accentHost = vr.closest('.product-sizes-colors--pdp2026q2');
    bindFleeceAccent(accentHost);
    vr.addEventListener('variants:change', function (e) {
      var v = e.detail && e.detail.variant;
      updateSpecCard(v);
      updateHeroImage(v);
      syncFleeceAccent(accentHost);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
